export const idpRes = {
  title: {
    en: 'Landsbankinn - Authentication',
    pl: 'Landsbankinn - Uwierzytelnianie',
    is: 'Landsbankinn - Auðkenning',
  },
};
